import React from 'react';
import classNames from 'classnames';
import './styles.css';

export default function Waves({ className, style }) {
  return (
    <div className={classNames('Components_waves', className)} style={style}>
      <span className="bg-primary" />
      <span className="bg-primary" />
      <span className="bg-primary" />
    </div>
  );
}
